import type { Selectable } from 'kysely'
import z from 'zod'

export type KeyDocumentEntity = {
  keyId: string
  documentId: string
}

export type KeyDocument = Selectable<KeyDocumentEntity>

export const keyDocumentSchema = z
  .object({
    keyId: z.uuid(),
    documentId: z.uuid(),
  })
  .meta({ id: 'key-documents' }) satisfies z.ZodType<KeyDocument>
